var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.99967C14 8.36786 13.7015 8.66634 13.3333 8.66634L4.27614 8.66634L7.13807 11.5283C7.39842 11.7886 7.39842 12.2107 7.13807 12.4711C6.87772 12.7314 6.45561 12.7314 6.19526 12.4711L2.19526 8.47108C1.93491 8.21073 1.93491 7.78862 2.19526 7.52827L6.19526 3.52827C6.45561 3.26792 6.87772 3.26792 7.13807 3.52827C7.39842 3.78862 7.39842 4.21073 7.13807 4.47108L4.27614 7.33301L13.3333 7.33301C13.7015 7.33301 14 7.63148 14 7.99967Z",
    fill: "#1F292E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_arrow_left.4153a3e6c7d9481d8fceecd54cc6c422.svg";